"use strict";

import "nodelist-foreach-polyfill";
import L from "leaflet";
import "leaflet-control-geocoder";

// id mapy
const mapId = "locality-select-map";

// default map center
const defaultCenterPoint = [50.12655, 14.4179];

// defaultZoom
const defaultZoom = 13;

// "styly" pro lokality
const options = {
  registered: {
    color: "red",
    opacity: 0.6,
    weight: 2,
  },
  unregistered: {
    color: "blue",
    opacity: 0.6,
    weight: 2,
  },
};

function init() {
  if (document.getElementById(mapId)) {
    // Inicializace mapy
    const map = L.map(mapId).setView(defaultCenterPoint, defaultZoom);

    // Přidání základních dlaždic
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    // Vytvoření vrstvy pro geometrii
    const geometryLayer = L.featureGroup().addTo(map);

    // lokality
    const localitiesElms = document.querySelectorAll("[data-locality-code]");
    localitiesElms.forEach((localityElm) => {
      try {
        const polylinePoints = JSON.parse(
          localityElm.dataset.localityPoints
        ).map((pointData) => [pointData.lat, pointData.lng]);

        // stylovani lokality
        const polylineStyles =
          localityElm.dataset.localityRegistered == 1
            ? options.registered
            : options.unregistered;

        // polygon
        const polygon = L.polygon(polylinePoints, polylineStyles).addTo(
          geometryLayer
        );

        // popup
        polygon.bindPopup(() => {
          // card header
          let cardHeaderHtml =
            "<strong>" + localityElm.dataset.localityDescription + "</strong>";
          cardHeaderHtml +=
            "<br />Kód lokality: " + localityElm.dataset.localityCode + "";

          // card body
          let cardBodyHtml = "";
          if (localityElm.dataset.localityRegistered != 1) {
            if (localityElm.dataset.localityRegistrationUrl) {
              cardBodyHtml =
                "<a href='" +
                localityElm.dataset.localityRegistrationUrl +
                "' class='btn btn-default btn-xs'>Přihlásit se ke sčítání…</a>";
            } else {
              cardBodyHtml = "<em>Nejste přihlášen/a.</em>";
            }
          } else {
            cardBodyHtml =
              "Sčitatel: " + localityElm.dataset.localityScrutiners + "";
          }

          return `<div class="card-content">${cardHeaderHtml}<br/>${cardBodyHtml}</div>`;
        });
      } catch (err) {
        console.log(
          "error locality",
          localityElm,
          localityElm.dataset.localityPoints
        );
      }
    });

    // prvotni zoom & center
    centerAndZoomMap(map, geometryLayer);

    // field pro vyhledevani
    const searchField = document.getElementById(
      "locality-select-map-search-field"
    );

    // submit button pro vyhledavani
    const submitButton = document.getElementById(
      "locality-select-map-search-submit"
    );

    // aktivace geocoderu
    const geocoder = L.Control.Geocoder.nominatim();
    const countryCode = "cz";

    // inicializace vyhledavani
    if (searchField && submitButton) {
      submitButton.addEventListener("click", (e) => {
        e.preventDefault();
        const searchString = searchField.value.trim();
        if (searchString) {
          geocoder
            .geocode(searchString, { countrycodes: countryCode })
            .then((result) => {
              const places = filterSearchResults(result, countryCode);
              if (places?.length) {
                centerAndZoomMap(
                  map,
                  geometryLayer,
                  [places[0].center.lat, places[0].center.lng],
                  defaultZoom
                );
              } else {
                alert("Místo nebylo nalezeno");
              }
            });
        }
      });
    }
  }
}

// vystredeni mapy a nastaveni zoomu
const centerAndZoomMap = (map, geometryLayer, center, zoom) => {
  if (!center && !zoom) {
    map.fitBounds(geometryLayer.getBounds());
  } else {
    map.setView(center, zoom);
  }
};

// filtrovani vysledku hledani (je potreba implementovat podle konkretniho geocoderu)
const filterSearchResults = (results, countryCode) => {
  const filteredResults = [];
  results.forEach((result) => {
    const { properties } = result;

    // defaultni geokoder (nominatim) zachazi dost volne s nastavenim filtrace podle země...
    if (properties?.address?.country_code !== countryCode) return;

    filteredResults.push(result);
  });
  return filteredResults;
};

// inicializace
document.addEventListener("DOMContentLoaded", function () {
  init();
});
